import React from 'react'
import Button from '../../../common/components/Button';

import {v4 as uuidv4} from 'uuid'
import { errorToast } from '../../../common/js/toast-utility';
import { axiosPost } from '../../../common/js/axios-utility';
import { CrumplePopSignupContext } from '../../contexts/CrumplePopSignupContext';

const ready = true;

export default function CrumplePopGoogleSignin({onComplete}) {
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);
    const channelName = React.useRef(null);

    const launchGoogle = () => {
        const url = getGoogleUrl(channelName.current);
        window.open(url, '_blank', 'height=600,width=400');
    }
    
    React.useEffect(() => {
        const id = uuidv4();
        channelName.current = "google-signin-" + id
        const bc = new BroadcastChannel(channelName.current);
        bc.onmessage = event => {
            handleSignIn(event.data);
        }
        return () => {
            bc.close();
        }
    }, []);

    const handleSignIn = async code => {
        setMigrationState({...migrationState, processing: true});
        try{
            const {data} = await axiosPost('/cpop/google', {code});
            if (data.success){
                const custData = data.data;
                const cpop_login = {token: custData.token, key: custData.public_key};
                Cookies.set('cpop_login', JSON.stringify(cpop_login))
                onComplete(custData);
            }
            else{
                console.error(data);
                throw new Error('Failed to sign in. Please try again.');
            }
        }
        catch(err){
            errorToast(err.message);
            setMigrationState({...migrationState, processing: false});
        }
    }

    return (
        <div className={ready ? 'google-signin-container' : 'google-signin-container'}>
            <Button className="btn btn-new btn-google" onClick={launchGoogle} label="Sign In With Google" />
        </div>
    )
}

const getGoogleUrl = channelName => {
    return (
        'https://accounts.google.com/o/oauth2/v2/auth?' + 
        'scope=' + encodeURIComponent('https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile') + 
        '&redirect_uri=' + encodeURIComponent(`https://borisfx.com/account/google-complete`) + 
        '&state=' + encodeURIComponent(`channel=${channelName}`) +
        '&response_type=code' +
        '&client_id=578782518691-nhi0g8oicc16sa3cpdrhjs6h9cnlmm70.apps.googleusercontent.com' +
        '&prompt=consent'
    );
}